import React from 'react';
import {StyleSheet, Text, View, ScrollView} from 'react-native';
import GoogleAutocomplete from "../common/GoogleAutocomplete";

const CampAddress = ({camp, setCamp}) => {
    return (
        <ScrollView style={styles.container} contentContainerStyle={styles.contentContainer}>
            <View style={styles.field}>
                <Text style={styles.title}>Camp Location</Text>
                <Text style={styles.subtitle}>Please enter the physical location of your camp.</Text>
            </View>

            <GoogleAutocomplete camp={camp} setCamp={setCamp}/>
        </ScrollView>
    );
};

const styles = StyleSheet.create({
    field: {
        flexDirection: 'column',
        marginBottom: 30,
    },
    container: {
        flex: 1,
    },
    contentContainer: {
        paddingHorizontal: 120,
        paddingTop: 40,
        paddingBottom: 40,
    },
    input: {
        height: 40,
        borderColor: 'gray',
        borderWidth: 1,
        marginBottom: 20,
        paddingHorizontal: 10,
    },
    title: {
        fontSize: 35,
        color: 'black',
        fontWeight: '600',
        marginBottom: 10,
    },
    subtitle: {
        fontSize: 15,
        color: 'grey',
    },
});

export default CampAddress;
